<template>
  <div id="repair-create-after">
    <file-upload-content @onFileChange="handleChangeImg" />
    <ul class="photo">
      <li
        class="photo-content"
        v-for="item in repairRecord.afterPhoto"
        :key="item.photoUid"
      >
        <img class="photo-content__img" :src="item.photoUrl" alt="" />
        <img
          @click="handleDelete(item.photoUid)"
          class="photo-content__delete"
          src="../../assets/images/disabled_delete.svg"
          alt=""
        />
      </li>
      <li class="photo-content"></li>
    </ul>
  </div>
</template>

<script>
import { getFileDataURL, getFileName } from '../../config/utils';
import fileUploadContent from '../layout/file-upload-content.vue';
export default {
  components: { fileUploadContent },
  props: {
    repairRecord: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    handleChangeImg({ files }) {
      Array.from(files).forEach(async (item, index) => {
        const test = await getFileDataURL(item, 'image');
        // getFileName
        const imgItem = {
          photoName: getFileName(item),
          photoTypeEnum: 1,
          photoUrl: test,
          file: item,
          photoUid: index + Date.now()
        };
        this.repairRecord.afterPhoto.push(imgItem);
      });
    },
    handleDelete(id) {
      const deleteIndex = this.repairRecord.afterPhoto.findIndex(item => {
        return item.photoUid == id;
      });
      this.repairRecord.afterPhoto.splice(deleteIndex, 1);
    }
  }
};
</script>

<style lang="scss">
#repair-create-after {
  .photo {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    position: relative;
    margin-top: 20px;
    &-content {
      position: relative;
      width: 195px;
      &__img {
        width: 195px;
        height: 140px;
      }
      &__delete {
        position: absolute;
        right: 5px;
        bottom: 5px;
        width: 30px;
        cursor: pointer;
      }
    }
  }
}
</style>
